<template>
  <div class="content">
    <h1 class="font-light">User Index</h1>
    <server-error v-bind:error="error.serverError"></server-error>
    <div class="row">
      <search-field
        v-bind:search="filters.search"
        @handleSearch="handleSearch"
      ></search-field>
      <div class="col-4">
        <div class="form-group u-pull-right">
          <filter-dropdown
            v-bind:options="filterOptions"
            v-on:handle-filter="handleFilter"
          ></filter-dropdown>
          <router-link
            v-if="permissions.includes('auth-taslytic.add_taslyticuser')"
            :to="{ name: 'user-create' }"
          >
            <button id="addButton" class="btn-info action-button">
              <span class="icon">
                <i
                  class="fa-wrapper fa fa-plus-circle normal-icon"
                  aria-hidden="true"
                ></i>
              </span>
              <span>Add</span>
            </button>
          </router-link>
        </div>
      </div>
    </div>
    <filter-tags v-bind:filterOptions="filterOptions"></filter-tags>
    <!-- User table -->
    <table class="table">
      <thead>
        <th></th>
        <th>Id</th>
        <th>Name</th>
        <th>ARN</th>
        <th class="tas-last-col">Groups</th>
      </thead>
      <tbody>
        <tr v-if="userList && userList.length == 0">
          <td colspan="7">
            <no-results-found
              title="No Users Found"
              message="Maybe change the search and filters and try again?"
            ></no-results-found>
          </td>
        </tr>
        <tr
          v-else
          v-for="(user, index) in userList"
          :key="'user-' + user.id + index"
        >
          <td>
            <button
              class="btn-small u-center u-pull-right"
              v-bind:class="getUserAction(user).class"
            >
              <router-link
                :to="{ name: 'user-change', params: { userId: user.id } }"
              >
                {{ getUserAction(user).label }}
              </router-link>
            </button>
          </td>
          <td>{{ user.id }}</td>
          <td>
            {{ user.full_name.length > 1 ? user.full_name : "[ Unknown ]" }}
          </td>
          <td>{{ user.arn.length > 1 ? user.arn : "--" }}</td>
          <td>
            <user-group-tags
              class="u-text-left"
              v-bind:groups="user.groups"
            ></user-group-tags>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<style>
.tas-last-col {
  width: 20rem;
  text-align: left !important;
}
</style>
<script>
import { mapGetters } from "vuex";
import { debounce } from "@/functions/debounce.function";
import { SetupFilters } from "@/services/filters.service";
import { GetSelectedFilters } from "@/services/filters.service";
import { HandleAllFilters } from "@/services/filters.service";
import SearchField from "@/components/SearchField";
import FilterDropdown from "@/components/FilterDropdown";
import FilterTags from "@/components/FilterTags";
import UserGroupTags from "@/components/UserGroupTags";
import ServerError from "@/components/ServerError";
import NoResultsFound from "@/components/PlaceholderNoResults";
import { titleCase } from "@/functions/titleCase.function";

export default {
  name: "user-index",
  components: {
    SearchField,
    FilterDropdown,
    FilterTags,
    UserGroupTags,
    ServerError,
    NoResultsFound
  },
  data: function() {
    return {
      filterOptions: {
        is_active: [
          { name: "True", value: "true", selected: false },
          { name: "False", value: "false", selected: false }
        ],
        is_admin: [
          { name: "True", value: "true", selected: false },
          { name: "False", value: "false", selected: false }
        ]
      }
    };
  },
  computed: {
    ...mapGetters("core", ["error"]),
    ...mapGetters("auth", [
      "userProfile",
      "permissions",
      "userList",
      "filters",
      "search"
    ])
  },
  watch: {
    search: debounce(function() {
      // This watches the filters.search model to debounce the input =)
      this.$store.dispatch("auth/getUserList");
      this.$router.replace({ name: "user-index", query: { ...this.filters } });
    }, 300),
    results: function() {
      this.setupResultFilter();
    }
  },
  methods: {
    titleCase: function(value) {
      return titleCase(value);
    },
    handleSearch: function(searchVal) {
      this.$store.commit("auth/filters", {
        search: searchVal
      });
    },
    handleFilter: function(payload) {
      HandleAllFilters(this.filters, this.filterOptions, payload);
      this.$store.commit("auth/filters", payload);
      this.$store.dispatch("auth/getUserList");
      this.$router.replace({
        name: "user-index",
        query: { ...this.filters }
      });
    },
    getUserAction: function(user) {
      let action = {};
      let has_change_perm = this.permissions.includes(
        "auth-taslytic.change_taslyticuser"
      );
      let is_self = user.id == this.userProfile.id;
      if (has_change_perm || is_self) {
        action.label = "Edit";
        action.class = "btn-primary";
      } else {
        action.label = "View";
        action.class = "btn-info outline";
      }
      return action;
    }
  },
  mounted() {
    // re-hydrate the filter with either the URL query or the values from the
    // Vuex store.
    SetupFilters(this, "auth.filters", "user-index");
    // Initialize the selected filters based on the URL query
    for (let key in this.$route.query) {
      GetSelectedFilters(this.filterOptions[key], this.$route.query[key]);
    }
    this.$store.dispatch("auth/getUserList");
    this.$store.commit("core/clearErrors");
  }
};
</script>
